export default __webpack_public_path__ + "static/media/splash.2c557171.jpg";